import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["avatar", "companyLogo", "companyName", "index", "isCurrent", "jobTitle", "name", "onClick", "review"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { BlockQuote, ReviewContainer, Review, Cite, Avatar, Name, JobTitle, Company } from "./testimonial.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Testimonial = function Testimonial(_ref) {
  var avatar = _ref.avatar,
    companyLogo = _ref.companyLogo,
    companyName = _ref.companyName,
    index = _ref.index,
    isCurrent = _ref.isCurrent,
    jobTitle = _ref.jobTitle,
    name = _ref.name,
    onClickProp = _ref.onClick,
    review = _ref.review,
    rest = _objectWithoutProperties(_ref, _excluded);
  var onClick = useCallback(function () {
    return onClickProp(index);
  }, [index, onClickProp]);
  return /*#__PURE__*/_jsxs(BlockQuote, _objectSpread(_objectSpread({
    className: "testimonial-".concat(index),
    "data-testid": "testimonial-blockquote",
    isCurrent: isCurrent,
    onClick: onClickProp ? onClick : null
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx(ReviewContainer, {
      children: /*#__PURE__*/_jsx(Review, {
        children: review
      })
    }), /*#__PURE__*/_jsxs(Cite, {
      children: [/*#__PURE__*/_jsx(Avatar, {
        alt: "",
        src: avatar
      }), /*#__PURE__*/_jsx(Name, {
        children: name
      }), /*#__PURE__*/_jsx(JobTitle, {
        children: jobTitle
      }), /*#__PURE__*/_jsx(Company, {
        alt: companyName,
        src: companyLogo
      })]
    })]
  }));
};
Testimonial.defaultProps = {
  transitionConfig: {},
  onClick: null
};
var testimonialInfoPropTypes = {
  avatar: PropTypes.string.isRequired,
  companyLogo: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  review: PropTypes.string.isRequired
};
Testimonial.propTypes = _objectSpread({
  index: PropTypes.number.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  transitionConfig: PropTypes.object
}, testimonialInfoPropTypes);
export var testimonialPropTypes = PropTypes.shape(testimonialInfoPropTypes);
export default /*#__PURE__*/memo(Testimonial);